
const ApiUrl = "https://administration-api.vacuactivskopje.mk";
const ServerDomain ="https://administration-api.vacuactivskopje.mk/";
const CMSBaseUrl = "https://cms.vacuactivskopje.mk";

export const environment = {
  production: true,
  apiUrl: ApiUrl,
  serverDomain: ServerDomain,
  cmsBaseUrl: CMSBaseUrl
};